export const container: CSSFunction = () => ({
  flexDirection: 'column',
  padding: '16px',
  width: '100%',
  gap: '16px',
});

export const row: CSSFunction = () => ({
  width: '100%',
  justifyContent: 'space-between',
  paddingRight: '84px',
});

export const subRow: CSSFunction = () => ({
  width: '176px',
  justifyContent: 'space-between',
});
